import {Link, useLocation} from 'react-router-dom';
import Button from '../Button';
import styles from './NavigationBar.module.scss';
import Logo from 'components/Logo';

const NavigationBar = () => {
  const pathname = useLocation();
  const isLogin = pathname.pathname === '/login';
  const navigationLink = isLogin ? '/signup' : '/login';
  const buttonText = isLogin ? 'Sign Up' : 'Sign In';
  return (
    <nav className={styles.navigation}>
      <div className={styles.container}>
        <div className={styles.header}>
          <a
            href={'https://magicdispatch.com'}
            target="_blank"
            rel="noreferrer"
          >
            <div className={styles.logo}>
              <div className={styles.logoIcon}>
                <Logo style={{width: 32, height: 32}} />
              </div>
              <span className={styles.logoText}>Magic Dispatch</span>
            </div>
          </a>

          {/* Desktop Navigation */}
          <div className={styles.desktopNav}>
            <Link to={navigationLink}>
              <Button className={styles.loginButton}>
                <span>{buttonText}</span>
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <div className={styles.mobileMenu}>
        {/* Mobile Menu Sidebar */}
        <div className={styles.mobileSidebar}>
          <div className={styles.mobileContent}>
            {/* Action Buttons */}
            <div className={styles.mobileActions}>
              <Button
                className={styles.mobileLoginButton}
                component="a"
                to={navigationLink}
              >
                <span>{buttonText}</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavigationBar;
